<template>
    <transition name="modal">
        <div class="popup-modal" v-if="isVisible">
            <div class="window">
                <slot></slot>
                <button @click="close">Close</button>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'ConfirmationModal',
    data: () => ({
        isVisible: false,
    }),
    methods: {
        open() {
            this.isVisible = true;
        },
        close() {
            this.isVisible = false;
        },
    },
};
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
    transition: all .3s ease;
}

.modal-enter,
.modal-leave-to {
    transform: scale(0);
    opacity: 0;
}

.popup-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}

.window {
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    width: 80%;
    max-width: 500px;
    box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.1);
}

.window button {
    background-color: #f97316;
    color: #fff;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    transition: background-color .3s ease;
}

.window button:hover {
    background-color: #f76000;
}
</style>
